import '../../form.css'
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import constant from '../../../../constant';
const Index = ({ state, onChange, onSubmit, isFinalSubmitting, setIsFinalSubmitting, history, handleFileChange }) => {

    return (
        <div className="row">
            <div className="col-md-12 ">
                <div className="appraisal-report-table-responsive">

                    {/* Comment */}
                    <div className="row">
                        <div className="col-lg-12">
                            <table className="mrt20">
                                <tbody>
                                    <tr>
                                        <td className="hd-b"><p>Comment</p></td>
                                    </tr>
                                    <tr>
                                        <td className="input-textarea">
                                            <textarea
                                                name={state.description.name}
                                                value={state.description.value}
                                                onChange={onChange}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Photos */}
                    <div className="row">
                        <div className="col-lg-12">
                            <table className="mrt20">
                                <tbody>
                                    <tr>
                                        <td className="hd-b"><p>Photos</p></td>
                                    </tr>
                                    <tr>
                                        <td className="input-textarea">
                                            <div className="photo-upload-box">
                                                <label htmlFor="photo-upload" className="upload-area">
                                                    Click here to upload photos
                                                </label>
                                                <input
                                                    type="file"
                                                    id="photo-upload"
                                                    accept="image/*"
                                                    multiple
                                                    style={{ display: "none" }}
                                                    onChange={handleFileChange}
                                                />
                                            </div>

                                            {/* Photo preview */}
                                            <div className="photo-preview">
                                                {state.photoPreview.map((preview, idx) => (
                                                    <div key={idx} style={{ display: "inline-block", margin: "5px", position: "relative" }}>
                                                        <img
                                                            src={preview}
                                                            alt="Preview"
                                                            style={{ width: "100px", height: "100px", objectFit: "cover", border: "1px solid #ccc" }}
                                                        />
                                                    </div>
                                                ))}

                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* Styling */}
                        <style jsx>{`
              .upload-area {
                display: block;
                padding: 20px;
                border: 2px dashed #999;
                text-align: center;
                cursor: pointer;
                border-radius: 8px;
                background: #f9f9f9;
              }
              .upload-area:hover {
                background: #f1f1f1;
              }
              .photo-preview {
                margin-top: 15px;
                display: flex;
                gap: 10px;
                flex-wrap: wrap;
              }
              .preview-img {
                width: 100px;
                height: 100px;
                object-fit: cover;
                border-radius: 6px;
                border: 1px solid #ddd;
              }
            `}</style>
                    </div>

                </div>

                {/* Builder Reply */}
                <div className="row appraisal-report-table-responsive">
                    <div className="col-lg-12">
                        <table className="mrt20">
                            <tbody>
                                <tr>
                                    <td className="hd-b"><p>Builder Reply :</p></td>
                                </tr>
                                <tr>
                                    <td className="input-textarea">
                                        <textarea
                                            name={state.builder_reply.name}
                                            value={state.builder_reply.value}
                                            onChange={onChange}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Checkbox */}
                <div className="final-checkbox">
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            name="discountCheckbox"
                            type="checkbox"
                            checked={isFinalSubmitting}
                            onChange={() => setIsFinalSubmitting(!isFinalSubmitting)}
                            id="productdiscountCheck1"
                        />
                        <label className="form-check-label" htmlFor="productdiscountCheck1">
                            Send to Office for Review
                        </label>
                    </div>
                </div>

                {/* Buttons */}
                <div className="row mt-4">
                    <div className="col-lg-12 text-left ">
                        <button
                            type="button"
                            className="btn btn-success"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e",
                            }}
                            onClick={onSubmit}
                        >
                            Submit
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger ms-3"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e",
                            }}
                            onClick={() =>
                                history.push(constant.Authedcomponent.siteManagement.url)
                            }
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Index)